import generateAsyncRouteComponent from '../generateAsyncRouteComponent';

export default {
  path: 'mastectomy-vat-exemption',
  component: generateAsyncRouteComponent({
    loader: () =>
      import('./containers/MastectomyVatExemptionRequestPageContainer'),
  }),
};
